var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 0C31.2903 0 0 31.2903 0 70C0 108.71 31.2903 140 70 140C108.71 140 140 108.71 140 70C140 31.2903 108.71 0 70 0ZM103.871 55.4839L62.4194 96.7742C61.1289 98.0647 59.5167 98.7093 57.9032 98.7093C56.2897 98.7093 54.5156 98.0647 53.3871 96.7742L32.9029 76.451C30.322 73.8701 30.322 69.8379 32.9029 67.2569C35.4838 64.676 39.5161 64.676 42.0971 67.2569L57.9032 83.0631L94.6774 46.2889C97.2583 43.708 101.291 43.708 103.872 46.2889C106.29 48.8709 106.29 53.0639 103.872 55.4842L103.871 55.4839Z",
    fill: "#7AD81B",
    fillOpacity: 0.8
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.4b7d91e6cc0a3b27bb59cc81beb4b4f9.svg";
export { ForwardRef as ReactComponent };